import { FC, useRef, useEffect, useState } from 'react';
import {
  shallowEqual,
  useSelector,
  connect,
  useDispatch,
  ConnectedProps,
} from 'react-redux';
import { LayoutSplashScreen } from '../../../../rbts/layout/core';
import * as auth from './AuthRedux';
import { getUserByToken } from './AuthCRUD';
import { RootState } from '../../../../setup';
import { SimpleAlert } from '../../../../rbts/helpers';

const mapState = (state: RootState) => ({ auth: state.auth });
const connector = connect(mapState, auth.actions);
type PropsFromRedux = ConnectedProps<typeof connector>;

const AuthInit: FC<PropsFromRedux> = (props) => {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const accessToken = useSelector<RootState>(
    ({ auth }) => auth.accessToken,
    shallowEqual
  );

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const user = await getUserByToken();
          dispatch(props.fulfillUser(user));
        }
      } catch (error: any) {
        if (!didRequest.current) {
          // Clear the invalid/restricted token first
          dispatch(props.logout());
          // Show login screen, then alert on top
          setShowSplashScreen(false);
          if (error.message === 'APP_ONLY_ROLE') {
            setTimeout(() => {
              SimpleAlert(
                'Acceso Restringido: Su perfil (Caja/Puesto) es de uso exclusivo en la Aplicación Móvil.',
                5000,
                'warning'
              );
            }, 300);
          }
          return;
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (accessToken) {
      requestUser();
    } else {
      dispatch(props.logout());
      setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
};

export default connector(AuthInit);
